<script lang="ts" setup>
import '@unocss/reset/tailwind.css'
import { onMounted, ref } from 'vue'
import { usePageTime, useTechAppHide, useTechHttpCost } from '@/composables/tracks'
import { theme } from '@/config/brands'

const loading = ref(true)
const { performanceObserver } = useTechHttpCost()
const { primaryColor, bgGlobal } = theme

function initApp() {
  performanceObserver()
  useTechAppHide()

  // 设置全局品牌主题 CSS 变量
  document.documentElement.style.setProperty('--primary-color', primaryColor)
}

onMounted(async () => {
  // eslint-disable-next-line no-console
  console.log('[App] => onMounted')
  loading.value = false

  usePageTime()
})
initApp()
</script>

<template>
  <div id="app">
    <div v-if="loading">
      <div class="pt-20vh flex justify-center">
        <BasicSpinner class="mx-auto" />
      </div>
    </div>

    <div v-else>
      <keep-alive>
        <router-view v-if="$route.meta?.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta?.keepAlive" />

      <BasicLoading />
      <BasicToast class="z-1001" />
    </div>

    <portal-target name="root" multiple />
  </div>
</template>

<style>
html, body {
  height: 100%;
  -webkit-overflow-scrolling: auto;
  overflow: hidden;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, SF UI Text, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;
  touch-action: pan-y;
  font-size: 16px;
  max-width: var(--var-max-body-width, 750px);
  margin: 0 auto;
  background-color: v-bind(bgGlobal);
}
#app {
  height: 100%;
  margin: 0 auto;
  background: v-bind(bgGlobal);
  position: relative;
  overflow-y: scroll;
}

/** Some global transition  */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* slide-left */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.4s ease;
}
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(100%);
}
/* slide-right */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.4s ease;
}
.slide-right-enter, .slide-right-leave-to {
  transform: translateX(-100%);
}

/** Some reset css */
p {
  margin: 0;
  overflow-wrap: anywhere;
}
div, input, textarea, button, select, a {
  -webkit-tap-highlight-color: transparent!important;
}
input:focus {
  outline: 0;
}
::-webkit-scrollbar {
  display: none;
}
.box-shadow {
  box-shadow: 0 2px 10px 0 rgba(220, 224, 228, 0.40);
}
</style>
